import React from "react";
import PropTypes from "prop-types";
import styles from "./ReportInfoItem.module.css";
import { useTranslation } from "react-i18next";

export function ReportInfoItem({ reportInfo, reportType }) {
  const {t} = useTranslation();
  const trendColors = {
    up: "#43BA32",
    same: "#FF9A00",
    down: "#ED1F24",
  };

  if (reportType == "major") {
    return (
      <div>
        <div className={styles.reportInfoContainer}>
          <div className={styles.item}>
            <span>{t("Businesses")}</span>
            <span
              style={{
                color: trendColors[reportInfo.businessesTotal.trend],
              }}
            >
              {reportInfo.businessesTotal.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>{t("Paid")}</span>
            <span
              style={{
                color: trendColors[reportInfo.businessesPaid.trend],
              }}
            >
              {reportInfo.businessesPaid.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>VIP</span>
            <span
              style={{
                color: trendColors[reportInfo.businessesVip.trend],
              }}
            >
              {reportInfo.businessesVip.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>Comp</span>
            <span
              style={{
                color: trendColors[reportInfo.businessesComp.trend],
              }}
            >
              {reportInfo.businessesComp.value}
            </span>
          </div>
        </div>

        <div className={styles.reportInfoContainer}>
          <div className={styles.item}>
            <span>{t("People")}</span>
            <span
              style={{
                color: trendColors[reportInfo.peopleTotal.trend],
              }}
            >
              {reportInfo.peopleTotal.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>{t("Paid")}</span>
            <span
              style={{
                color: trendColors[reportInfo.peoplePaid.trend],
              }}
            >
              {reportInfo.peoplePaid.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>VIP</span>
            <span
              style={{
                color: trendColors[reportInfo.peopleVip.trend],
              }}
            >
              {reportInfo.peopleVip.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>Comp</span>
            <span
              style={{
                color: trendColors[reportInfo.peopleComp.trend],
              }}
            >
              {reportInfo.peopleComp.value}
            </span>
          </div>
        </div>

        <div className={styles.reportInfoContainer}>
          <div className={styles.item}>
            <span>{t("In Person")}</span>
            <span
              style={{
                color: trendColors[reportInfo.inPerson.trend],
              }}
            >
              {reportInfo.inPerson.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>Virtual</span>
            <span
              style={{
                color: trendColors[reportInfo.virtual.trend],
              }}
            >
              {reportInfo.virtual.value}
            </span>
          </div>
        </div>

        <div className={styles.divider} />
      </div>
    );
  } else {
    return (
      <div>
        <div className={styles.reportInfoContainer}>
          <div className={styles.item}>
            <span>{t("Premier +")}</span>
            <span
              style={{
                color: trendColors[reportInfo.totalPremierPlus.trend],
              }}
            >
              {reportInfo.totalPremierPlus.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>{t("Premier")}</span>
            <span
              style={{
                color: trendColors[reportInfo.totalPremier.trend],
              }}
            >
              {reportInfo.totalPremier.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>{t("Basic")}</span>
            <span
              style={{
                color: trendColors[reportInfo.totalBasic.trend],
              }}
            >
              {reportInfo.totalBasic.value}
            </span>
          </div>
          <div className={styles.item}>
            <span>Comp</span>
            <span
              style={{
                color: trendColors[reportInfo.totalComp.trend],
              }}
            >
              {reportInfo.totalComp.value}
            </span>
          </div>
        </div>

        <div className={styles.divider} />
      </div>
    );
  }
}

ReportInfoItem.propTypes = {
  reportInfo: PropTypes.object,
};
